import { atom } from 'recoil'
import ColumnType from '../types/ItemType'

export const ItemRecoilState = atom<ColumnType>({
  key: 'item',
  default: {
    status: [{ purchaseStatus: '', id: 0 }],
    subcontractings: [
      {
        subcontractorName: '',
        subcontractorCode: '',
        subcontractorAbbreviation: '',
        paymentTerms: '',
        memo: '',
        invoiceNumber: '',
      },
    ],
    subcontractingsContact: [{ addressType: '' }],
    rohs: [],
    businessUnit: [{ id: 0, businessUnitName: '' }],
    employmentStatus: [{ employmentStatus: '', id: 0 }],
    authority: [{ authorityName: '', id: 0 }],
    customer: [{ customerName: '', id: 0 }],
    user: [
      {
        Authority: undefined,
        AuthorityId: '',
        activate: 0,
        authUserId: '',
        divisionId: 0,
        divisionName: '',
        email: '',
        employeeNumber: '',
        employmentStatusId: 0,
        familyName: '',
        givenName: '',
        hour: '',
        otherDivisionId: 0,
        presumed: 0,
        tempAgencyId: 0,
        userId: 0,
      },
    ],
    division: {
      main: {
        id: 0,
        divisionCode: '',
        divisionName: '',
      },
      other: [{ divisionCode: '' }],
      all: [
        {
          id: 0,
          divisionCode: '',
          divisionName: '',
          tel: '',
          fax: '',
          memo: '',
          businessUnit: { business_unit_name: '', id: 0 },
        },
      ],
    },

    customerOrder: {
      activate: [
        {
          id: 0,
          order_number: '',
          parts_name: '',
          company_id: 0,
          customer: '',
          orderType: 0,
          divisionNumber: 0,
          free1Name: '',
          free2Name: '',
          createdUser: '',
          createdAt: '',
          updatedUser: '',
          updatedAt: '',
          activate: 0,
        },
      ],
      all: [
        {
          id: 0,
          order_number: '',
          parts_name: '',
          company_id: 0,
          customer: '',
          orderType: 0,
          divisionNumber: 0,
          free1Name: '',
          free2Name: '',
          createdUser: '',
          createdAt: '',
          updatedUser: '',
          updatedAt: '',
          activate: 0,
        },
      ],
    },

    tag: {
      activate: [
        {
          id: 0,
          word_category: '',
        },
      ],
      all: [
        {
          id: 0,
          word_category: '',
        },
      ],
    },
  },
})
